import { React, useState, useEffect } from 'react';
import validator from "validator";
import ReCAPTCHA from "react-google-recaptcha";

import '../style/header.scss';

import close from "../images/svg/close.svg";
import tick from "../images/svg/tick.svg";
import feedback from "../images/svg/feedback.svg";

const Feedback = () => {
	
	const [popUpBox, setPopUpBox] = useState(false);
	
	const [feedbackData, setFeedbackData] = useState({email:"", description:"",});
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	const [checkEmailData, setCheckEmailData] = useState(false);
	const [checkDescData, setCheckDescData] = useState(false);
	const [checkCeptcha, setCheckCeptcha] = useState(false);
	const [feedbackThanks, setFeedbackThanks] = useState(false);
	const [emailMessageValue, setEmailMessageValue] = useState(false);
	const [emailMessage, setEmailMessage] = useState("");
	var email = "";
	var description = "";
	var captchaValue = "";
	var getLoginUserData = null;
	var loginUserUid = '';
	var sBrowser, sUsrAg = navigator.userAgent;
	
	const getUserData = () => {
		getLoginUserData = JSON.parse(localStorage.getItem("loginUserData"));
		//console.log(getLoginUserData);
		if(getLoginUserData != null) {
			loginUserUid = getLoginUserData.uid;
			//console.log(loginUserUid);
		}
	}
	useEffect(() => {
		getUserData();
	}, []);
	
	function onChange(value) {
		captchaValue = value;
		//console.log("Captcha value:", value);
	}
	
	const handleChange = (e) => {
		setFeedbackData(prev => ({...prev, [e.target.name]:e.target.value}));
	}
	//console.log(feedbackData);
	
	const validateEmail = (e) => {
		var email = e.target.value;

		if (validator.isEmail(email)) {
			setEmailMessage("");
			setEmailMessageValue(true);
		} else {
			setEmailMessage("Please, enter valid Email!");
		}
		
		if(email == ""){
			setCheckEmailData(true);
			setEmailMessage("");
		} else{
			setCheckEmailData(false);
		}
	};
	
	const twoCalls = (e) => {
		handleChange(e);
		validateEmail(e);
	}
	
	const sendFeedbackData = (e) => {
		e.preventDefault();
		email = feedbackData.email;
		//console.log(email);
		description = feedbackData.description;
		//console.log(description);
		
		//console.log(sBrowser);
		
		const sendData = async () => {
			try {
				const requestOptions = {
					method: 'POST'
				};
				const response = await fetch(
					'https://p1.squareoffnow.com/api/ichess?uid='+loginUserUid+'&email='+email+'&saveFeedback=1&message='+description+'&browserInfo='+sBrowser+'' , requestOptions
				);
				if (!response.ok) {
					throw new Error(
					`This is an HTTP error: The status is ${response.status}`
					);
				}
				let actualData = await response.json();
				//setData(actualData);
				setData(actualData);
				//console.log(actualData);
				setError(null);
			} catch(err) {
				setError(err.message);
				setData(null);
			} 
		}
		
		if(email == ""){
			setCheckEmailData(true);
			setEmailMessage("");
		} else{
			setCheckEmailData(false);
		}
		if(description == ""){
			setCheckDescData(true);
		} else{
			setCheckDescData(false);
		}
		if(captchaValue == ""){
			setCheckCeptcha(true);
		} else{
			setCheckCeptcha(false);
		}
		
		if(email != "" && description != "" && emailMessageValue && captchaValue){
			sendData();
			setFeedbackThanks(true);
		}
		
		
	}
	
	const openPopUp = () => {
		setPopUpBox(true);
	}
	
	const closePopUp = () => {
		setPopUpBox(false);
		if(feedbackThanks){
			window.location.reload(false);
		}
		setFeedbackThanks(false);
	}

	
	// The order matters here, and this may report false positives for unlisted browsers.
	if (sUsrAg.indexOf("Firefox") > -1) {
		sBrowser = "Mozilla Firefox";
		// "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
	} else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
		sBrowser = "Samsung Internet";
		// "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
	} else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
		sBrowser = "Opera";
		// "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
	} else if (sUsrAg.indexOf("Trident") > -1) {
		sBrowser = "Microsoft Internet Explorer";
		// "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
	} else if (sUsrAg.indexOf("Edge") > -1) {
		sBrowser = "Microsoft Edge";
		// "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
	} else if (sUsrAg.indexOf("Chrome") > -1) {
		sBrowser = "Google Chrome or Chromium";
		// "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
	} else if (sUsrAg.indexOf("Safari") > -1) {
		sBrowser = "Apple Safari";
		// "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
	} else {
		sBrowser = "unknown";
	}
	
	return (
		
		<div className="wdh">
			
			<span className="Feedback-icon-click" onClick={() => openPopUp() }> <img src={feedback} className="feedback-svg" alt="icon" /></span>
			
			<div className={'feedback-overlay popup-overlay' + (popUpBox  ? '' : ' hide')}>
				<div className="popup-flex">
					<div className={'feedback-box popup-box' + (popUpBox  ? ' animate' : '')}>
						<img src={close} onClick={() => closePopUp()} className="rules-close-button popup-close-button" alt="icon" />
						<div className={feedbackThanks ? 'hide' : ''}>
							<h3 className="rules-title align-center">Feedback</h3>
							<div className="form-box">
								<form >
									<div className="feddback-input-box">
										<input type="email" name="email" onChange={twoCalls} className="feedback-inpt" placeholder="Please enter your email id" required/>
										<p className={checkEmailData ? '' : 'hide'}>Please enter your email</p>
										<p>{emailMessage}</p>
									</div>	
									<div className="feddback-input-box">
										<textarea name="description" onChange={handleChange} rows="4" cols="40" className="feedback-inpt" placeholder="Start typing your feedback here..." ></textarea>
										<p className={checkDescData ? '' : 'hide'}>Please enter your message</p>
									</div>	
									<div className="feddback-input-box fib">
										<ReCAPTCHA sitekey="6LdokKIgAAAAAAZFLOeaqaXnGU5JFsFVt9QnPMXW" onChange={onChange} />
										<p className={checkCeptcha ? '' : 'hide'}>Please select "I am not a Robot"</p>
									</div>	
									<input type='submit' onClick={sendFeedbackData} value='Send Feedback' className='feedback-submit button-click' />
								</form>
							</div>
						</div>
						<h3 className={'thanks-title align-center' + (feedbackThanks ? '' : ' hide')}> <img src={tick} className="tick-svg" alt="icon" />Thank you for your feedback</h3>	
					</div>
				</div>
			</div>
			
		</div>

	);

  
}

export default Feedback;